// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pathFill":"OSkgAj","dash":"_1nq2hy"};